module.exports = __webpack_public_path__ + "static/media/uniempleo-logo-nuevo.1cbef0b3.png";